import React, {Component} from 'react'
import {TimelineMax, Power2} from 'gsap'

import Background from '../common/Background'

import logo from '../../assets/images/hart.svg'
import contactBG from '../../assets/images/contact/contact-bg.jpg'


class Contact extends Component {

    componentDidMount() {

        if (window.innerWidth > 768) {
            //settings objects

            const image = document.getElementsByClassName('image-holder')
            const imgLogo = document.getElementsByClassName('logo-contact')
            const heading = document.getElementsByClassName('heading')
            const branches = document.getElementsByClassName('branch')

            // define
            let timeline = new TimelineMax()

            // setter
            timeline.set(image, {opacity: 0, scale: 1})
            timeline.set(imgLogo, {opacity: 0, y: '-50'})
            timeline.set(heading, {opacity: 0, x: '-50'})
            timeline.set(branches, {opacity: 0, y: '50'})

            // Animation
            timeline
                .to(image, 2.5,
                    {
                        scale: 1,
                        opacity: 1,
                        ease: Power2.easeOut
                    })
                .to(imgLogo, 2,
                    {
                        opacity: 1,
                        y: 0,
                        ease: Power2.easeOut
                    }, '-=1')
                .to(heading, 2,
                    {
                        opacity: 1,
                        x: 0,
                        ease: Power2.easeOut
                    }, '-=1')
                .staggerTo(branches, 1,
                    {
                        opacity: 1,
                        y: 0,
                        ease: Power2.easeOut
                    }, 0.2, '-=1.5')
        }
    }

    render() {
        return (
            <div id="contact">

                <div className="image-holder">
                    <Background src={contactBG}/>
                </div>

                <div className="display-table">

                    <div className="display-cell">
                        <h1 className="heading">
                            GET IN TOUCH
                        </h1>
                        <div className="branch">
                            <h2>Karachi <span>Headquarters</span></h2>
                            <p>
                                4th Floor, S-213, Gulshan-e-Asghar, Shahra-e-Faisal<br/> Karachi - Pakistan<br/>
                                +92-213-468-4107
                            </p>
                            <a href="mailto:info@hartcommunications.com.pk" className="email">info@hartcommunications.com.pk</a>
                        </div>

                    </div>

                    <div className="display-cell image">
                        <img src={logo} className="logo-contact" alt="Hart Communications"/>
                    </div>

                </div>
            </div>
        )
    }
}

export default Contact


// WEBPACK FOOTER //
// ./src/components/Pages/Contact.js